export default __webpack_public_path__ + "static/media/640_business03-nl-mobile.6fa9bcdb.png";